// src/contexts/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [hideImages, setHideImages] = useState(false);

  // Load saved language preference on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'hi')) {
      setCurrentLanguage(savedLanguage);
    }
    const savedHide = localStorage.getItem('hideImages');
    if (savedHide === 'true') setHideImages(true);
  }, []);

  useEffect(() => {
    localStorage.setItem('selectedLanguage', currentLanguage);
  }, [currentLanguage]);

  useEffect(() => {
    localStorage.setItem('hideImages', hideImages ? 'true' : 'false');
  }, [hideImages]);

  const switchLanguage = (newLanguage) => {
    if (newLanguage === 'en' || newLanguage === 'hi') {
      setCurrentLanguage(newLanguage);
    }
  };

  const toggleImages = () => setHideImages((v) => !v);

  const getLanguageDisplay = () => {
    return currentLanguage === 'en' ? '🇺🇸 English' : '🇮🇳 हिंदी';
  };

  const value = {
    currentLanguage,
    switchLanguage,
    getLanguageDisplay,
    isEnglish: currentLanguage === 'en',
    isHindi: currentLanguage === 'hi',
    hideImages,
    toggleImages,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};